module.exports = __webpack_public_path__ + "img/coreintercomDesk.3b611460.png";